import { FunctionComponent, ReactNode } from 'react';
import { Box, SxProps } from '@mui/material';
import { GetResponsiveWidth } from '../common/TabsComponent';

interface SustainabilityContainerProps {
    children: ReactNode;
    backgroundColor?: string;
}

const SustainabilityContainer: FunctionComponent<SustainabilityContainerProps> = ({
    children,
    backgroundColor,
}) => {
    const splitScreenLayoutStyles: SxProps = {
        display: 'flex',
        justifyContent: 'space-between',
        paddingTop: '4rem',
        paddingBottom: '4rem',
        flexDirection: 'row',
        overflowY: 'hidden',
        backgroundColor: backgroundColor ?? 'white',
        width: GetResponsiveWidth(),
        alignItems: 'flex-start',
        margin: 'auto',
    };

    return <Box sx={splitScreenLayoutStyles}>{children}</Box>;
};

export default SustainabilityContainer;
